module.exports = __webpack_public_path__ + "static/media/react_native.f176859a.jpg";